import { Instrument } from '@toro/common/shared/models/quote/instrument.model';
import { Component, ViewEncapsulation, EventEmitter, Output, ViewChild, ChangeDetectorRef, OnDestroy, HostListener, OnInit } from '@angular/core';
import { TrWarrantyUsageComponent } from '../common/tr-warranty-usage/tr-warranty-usage.component';
import { CheckoutScenarioSettings } from '../checkout-scenario.settings';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { InvestmentResumeComponent } from '../dialogs/investment-resume/investment-resume.component';
import { CheckoutCommonResources } from '../common/checkout-common-resources/checkout-common-resources';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { fadeInOut } from '@toro/common/shared/animations/fadeInOut';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { MatDialogRef } from '@angular/material/dialog';
import { StockOrderType } from '@toro/common/shared/models/stocks-exchange/stock-order.model';
import { StrategyRequestLegPriceType } from '@toro/common/shared/models/stocks-exchange/strategy-request-leg-price-type.enum';
import { StrategyRequestLegValidityType } from '@toro/common/shared/models/stocks-exchange/strategy-request-leg-validity-type.enum';
import { StrategyRequestOrderType } from '@toro/common/shared/models/stocks-exchange/strategy-request-order-type.enum';
import { StocksExchangeCheckoutAction } from '../../../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.action';
import { ApplicationMessagesAction } from '@toro/common/shared/state-management/application-messages/application-message.action';
import { StrategyRequest } from '@toro/common/shared/models/stocks-exchange/strategy-request.model';
import { StockCheckoutType } from '@toro/common/shared/models/stocks-exchange/stock-checkout.model';
import { Subscription } from 'rxjs/Subscription';
import { ResearchActions } from '@toro/common/shared/state-management/research/research.action';
import { ComputerService } from '@toro/common/shared/services/computer/computer.service';
import { ComputingParameter } from '@toro/common/shared/models/computing-parameter/computing-parameter.model';
import { CalculatingScenario } from '@toro/common/shared/enum/calculating-scenario/calculation-scenario.enum';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { MarketScenario } from '@toro/common/shared/enum/market-scenario/market-scenario.enum';
import { DecimalPipe, DatePipe, Location, CurrencyPipe } from '@angular/common';
import { StocksExchangeWalletAction } from '@toro/common/shared/state-management/stocks-exchange-wallet/stocks-exchange-wallet.action';
import { OrderOriginTypeEnum } from '@toro/common/shared/enum/orders/origin-type.enum';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { OrderSideEnum } from '@toro/common/shared/enum/orders/side.enum';
import { OrderStatus } from '@toro/common/shared/enum/orders/order-status.enum';
import { TrPlannedCheckoutInputComponent } from '@toro/common/shared/components/tr-planned-checkout-input/tr-planned-checkout-input.component';
import { BillingAction } from '../../../../state-management/billing/billing.action';
import { KeyStocks } from '@toro/common/shared/enum/key-stocks/key-stocks.enum';
import { BrokeragePlatform } from '@toro/common/shared/enum/billing/brokerage-platform.enum';
import { StocksExchangeWalletEffects } from '@toro/common/shared/state-management/stocks-exchange-wallet/stocks-exchange-wallet.effects';
import { VirtualTypeEnum } from '@toro/common/shared/enum/orders/virtual-type.enum';
import { BillingEffects } from '../../../../state-management/billing/billing.effects';
import { RouterTrackerService } from '@toro/common/shared/services/router-tracker/router-tracker.service';
import { HubAuthorizationComponent } from '@toro/common/shared/components/hub-authorization/hub-authorization.component';
import { ConfirmEnableWarrantyComponent } from '../dialogs/confirm-enable-warranty/confirm-enable-warranty.component';
import { BrokerageModel } from '@toro/common/shared/enum/billing/brokerage-model.enum';
import { IStressResponse } from '@toro/common/shared/interfaces/pos-risk/stress.interface';
import { ResearchAdviceLite } from '@toro/common/shared/models/research/research-opportunity.model';
import { ResearchEffects } from '@toro/common/shared/state-management/research/research.effects';
import { StocksExchangeCheckoutEffects } from '../../../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.effects';
import { SegmentCheckoutTypeEnum } from '@toro/common/shared/enum/segment/segment-checkout-type.enum';
import { SegmentMarketTypeEnum } from '@toro/common/shared/enum/segment/segment-market-type.enum';
import { SegmentOrderSideEnum } from '@toro/common/shared/enum/segment/segment-order-side.enum';
import { OrderType } from '@toro/common/shared/enum/orders/order-type.enum';
import { STOCK_LOGO_PLACEHOLDER } from '@toro/common/shared/resources/consts';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { TrConfirmButtonsComponent } from '@toro/common/shared/components/tr-confirm-buttons/tr-confirm-buttons.component';
import { SecurityCategory } from '@toro/common/shared/enum/security-category.enum';
import { StockResearchTrendAction } from '../../../../state-management/stock-research-trend/stock-research-trend.action';
import { OverlaySimpleComponent } from '@toro/common/shared/components/dialogs/overlay-simple/overlay-simple.component';
import { StocksMarketInteractionsService } from '../../services/stocks-market-interactions.service';
import { OrderSentEvent } from '@toro/common/shared/models/segment/order-sent-event.model';
import { OperationType } from '@toro/common/shared/enum/orders/operation-type.enum';
import { ToastrService } from 'ngx-toastr';
import { AgreementsAction } from '@toro/common/shared/state-management/agreements/agreements.action';
import { filter, skip, first, map } from 'rxjs/operators';
import { AgreementsOptions } from '@toro/common/shared/enum/agreement/agreements-options.enum';
import { combineLatest, merge } from 'rxjs';
import { SuitabilityBypassAgreementActions } from '../../../../state-management/suitability-bypass-agreement/suitability-bypass-agreement.action';
import { ExchangeActions } from '../../../../state-management/exchange/exchange.action';

import { Icvm617Service } from '@toro/common/shared/services/icvm-617';
import { environment } from '@hub-workspace/apps/stock/src/environments/environment';

const disclaimerEasterEggTriggerAmount = 3;
const easterEggKey = 'T';

@Component({
    selector: 'stockhome',
    templateUrl: './planned-checkout.component.html',
    styleUrls: ['./planned-checkout.component.scss'],
    animations: [fadeInOut],
    encapsulation: ViewEncapsulation.Emulated,
})

export class PlannedCheckoutComponent extends CheckoutCommonResources implements OnInit, OnDestroy {

    @Output() public onValuesLockingChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @ViewChild(TrWarrantyUsageComponent, {static: true}) public warranyUsageComponent: TrWarrantyUsageComponent;
    @ViewChild('gainValueInput', {static: false}) public gainValueInput: TrPlannedCheckoutInputComponent;
    @ViewChild('stopValueInput', {static: false}) public stopValueInput: TrPlannedCheckoutInputComponent;
    @ViewChild('confirmButtons', {static: false}) public confirmButtons: TrConfirmButtonsComponent;

    public disposableSubscriptions: Subscription[] = [];
    public isMobile: boolean = false;
    public lockInvestValue: boolean = false;
    public lockStopValue: boolean = true;
    public gainValueEditingEnabled: boolean;
    public stopValueEditingEnabled: boolean;
    public lockGainValue: boolean = true;
    public alreadyUnlocked: boolean = false;
    public timeLastQuote: Date = null;
    public trendCompany: any = null;
    public legalAdvice: string = 'https://cdn.toroinvestimentos.com.br/corretora/documents/aviso-legal.pdf';
    public marketOpen = false;
    public securityCategory = SecurityCategory;
    public stockStress: number;
    public daytradeStress: number;
    public isPtax: boolean;
    public selectedLotAmount: number = 0;
    public defaultStress: number = null;
    public adviceId: number;
    public stopGainVariation: number = 0;
    public stopLossVariation: number = 0;
    public counter = 0;
    public dayTradeStatus: boolean = false;
    public guarantee: number = 100;
    public authorizationPanel: MatDialogRef<HubAuthorizationComponent>;
    public form: FormGroup;
    public inputIncreaseLimitConfirmation: any;
    public loadingAdvice: boolean = false;
    public loading: boolean = true;
    public unitPrice: number;
    public stockId: string;
    public symbol: any = {};
    public advice: ResearchAdviceLite = {} as any;
    public symbolLogo: string = '';
    public brokerageTax: number = 0;
    public isBovespaBuyPosition: boolean = false;
    public isSummerTime: boolean;
    public dialogComponentReference: MatDialogRef<InvestmentResumeComponent>;
    public closingLocalTime: string;
    public closingTime: string;
    public openingTime: string = '';
    public fusoLocalTime = new Date().toLocaleTimeString();
    public scenarioSettings: CheckoutScenarioSettings = new CheckoutScenarioSettings();
    public rlpModelAgreement: any;
    public showLoader: boolean = false;
    public rlpOption: boolean = false;
    public userIdentifier: string = null;
    public agreements: any[] = [];
    public hasBypassedSuitabilityForCurrentInvestment = false;
    public suitability: string = '';
    private dayTradeTooltip: any;
    private DEFAULT_TIME_F_IBOVESPA = '16:30';
    private DEFAULT_TIME_F_BMF = '17:30';
    private DEFAULT_TIME_L = '18:30';
    private DOLAR_PTAX: string = KeyStocks.DolPtax;
    private BROKERAGE_PLATFORM: string = BrokeragePlatform.Hub;
    private stockMarket: number;
    private enumOrderType: OrderType;
    private stockCheckout: any;
    private stopGainAnalyst: number = 0;
    private stopLossAnalyst: number = 0;
    private marketScenario: any;
    private ptaxQuote: number = null;
    private strategy: any = {};
    private ptaxAlreadySubscribed: boolean = false;
    private urlPriceTable = '/info/custos#tabela-tradicional';
    private warrantyValue: number;
    private usingWinWinModel: boolean = true;
    private stress: any;
    private trendDetails$: Observable<any>;
    private trendSubscribe: Subscription;
    private rlpInfoUrl: string = 'https://blog.toroinvestimentos.com.br/rlp-o-que-e-e-como-funciona-o-provedor-de-liquidez';


    public get tooltipDayTrade(): string {
        return `<div>
            <div class='pop-title'>Após ${this.timeLimitToDaytrade}</div>
            <div class='pop-content'>O investimento vai ser encerrado no fim do dia, antes do mercado fechar.</div>
        </div>`;
    }

    // controle de edição
    private executedAmount: number = 0;
    private executedPrice: number = 0;
    private input: any;
    private stopLoss: any;
    private stopGain: any;
    private CBLC: number = 0;
    private successScreenIsVisible: boolean;

    /**
     * texto de teste para ajudar nos testes de calculo, deve ser tirado após validação
     */
    public get labelTest() {
        let message = `Quantidade: ${this.selectedLotAmount} | `;
        message += `Cotação: ${this.unitPrice} | `;
        message += `Fator: ${this.symbol.quoteFactor} | `;
        message += `Estresse Estrategia: ${this.stockStress} | `;
        message += `Estresse Default: ${this.defaultStress} | `;
        message += `Loss: ${this.unitPriceWithLoss} | `;
        message += `gain: ${this.unitPriceWithGain} | `;
        message += `unlocked: ${this.alreadyUnlocked} | `;
        message += `last Quote: ${this.timeLastQuote.toLocaleString()}`;

        return message;
    }

    public get timeLimitToDaytrade(): string {
        return this.isFuture ? this.DEFAULT_TIME_F_BMF : this.DEFAULT_TIME_F_IBOVESPA;
    }

    public get showCalculusDataEasterEgg() {
        return this.counter === disclaimerEasterEggTriggerAmount;
    }

    public get showTogglePlanning() {
        return this.scenarioSettings.showTogglePlanningButton && this.scenarioSettings.enableGainStopEditing;
    }

    /** Valor disponível para investimento */
    public get avaliableValueToInvest() {
        return this.warranyUsageComponent.avaliableValue || 0;
    }

    /** Valor do investimento */
    public get value(): number {
        return this.form.controls.investmentValue.value
            ? this.form.controls.investmentValue.value
            : this.valueForInvestiment;
    }

    /** Label inferior do componente com o valor do ganho/lucro */
    public get gainBottomLabel() {
        const type = this.getUnitNameByMarket(false);
        let value = this.unitPriceWithGain - this.unitPrice;
        if (!value) value = 0;

        let doOuDa = 'da';
        let stringValue = this.currencyPipe.transform(Math.abs(value), 'BRL', 'symbol');
        const sobeOuDesce = this.scenarioSettings.purchase ? 'subir' : 'cair';

        if (this.isFuture) {
            doOuDa = 'do';
            stringValue = this.numberPipe.transform(Math.abs(value), '1.2-5') + ' pts';
        }

        return `Se o preço ${doOuDa} ${type} ${sobeOuDesce} ${stringValue}`;

    }

    /** Label inferior do componente com valor de stop/perda */
    public get lossBottomLabel() {

        const type = this.getUnitNameByMarket(false);
        let value = this.unitPrice - this.unitPriceWithLoss;
        if (!value) value = 0;

        let doOuDa = 'da';
        let stringValue = this.currencyPipe.transform(Math.abs(value), 'BRL', 'symbol');
        const sobeOuDesce = this.scenarioSettings.purchase ?  'cair' : 'subir';

        if (this.isFuture) {
            doOuDa = 'do';
            stringValue = this.numberPipe.transform(Math.abs(value), '1.2-5') + ' pts';
        }

        return `Se o preço ${doOuDa} ${type} ${sobeOuDesce} ${stringValue}`;
    }

    /* Label inferior do componente com o valor do investimento */
    public get investmentValueLabel() {

        const type = this.getUnitNameByMarket(this.selectedLotAmount !== 1);
        const side = this.scenarioSettings.purchase ? 'comprar' : 'vender';
        let stringValue = this.currencyPipe.transform(this.unitPrice, 'BRL', 'symbol');
        if (this.isFuture && this.unitPrice) {
            stringValue = this.numberPipe.transform(this.unitPrice, '1.2-5') + ' pts';
        }

        return [`para ${side}`,
            this.selectedLotAmount,
            `${type} a ${stringValue}`,
        ].join(' ');
    }

    public get unitPriceWithGain() {
        return this.calculateStopPrice(this.scenarioSettings.purchase, true, this.stopGainVariation);
    }

    public get unitPriceWithLoss() {
        return this.calculateStopPrice(this.scenarioSettings.purchase, false, this.stopLossVariation);
    }

    /**
     * valor da cotação já com o ganho esperado do Analista aplicado
     */
    public get AnalystUnitPriceWithGain() {
        if (this.isFuture) {
            return this.unitPrice + this.stopGainAnalyst;
        } else {
            return this.unitPrice * (1 + (this.stopGainAnalyst / 100));
        }
    }

    /**
     * valor da cotação já com o perda esperada do Analista aplicado
     */
    public get AnalystUnitPriceWithLoss() {
        if (this.isFuture) {
            return this.unitPrice - this.stopLossAnalyst;
        } else {
            return this.unitPrice * (1 - (this.stopLossAnalyst / 100));
        }
    }

    public get gainValue(): number {
        const calculatedPrice = this.computerService.ComputeStopValue(
            this.selectedLotAmount,
            this.symbol.quoteFactor,
            this.unitPrice,
            this.unitPriceWithGain,
            this.isFuture,
        );
        return isFinite(calculatedPrice) ? this.roundWithTwoDecimalPlace(calculatedPrice) : 0;
    }

    public get lossValue(): number {
        const calculatedPrice = this.computerService.ComputeStopValue(
            this.selectedLotAmount,
            this.symbol.quoteFactor,
            this.unitPrice,
            this.unitPriceWithLoss,
            this.isFuture,
        );
        return isFinite(calculatedPrice) ? this.roundWithTwoDecimalPlace(calculatedPrice) : 0;
    }

    public get valueForStandardLot() {
        const param = new ComputingParameter(
            this.symbol.standardLot,
            this.unitPrice,
            this.symbol.quoteFactor,
            this.stockStress,
            this.unitPriceWithLoss,
            this.isPtax ? this.ptaxQuote : null,
            this.defaultStress,
        );

        return this.computerService.calculate(this.marketScenario, this.calculatingScenario, param);
    }

    public get valueForInvestiment() {

        const param = new ComputingParameter(
            this.selectedLotAmount,
            this.unitPrice,
            this.symbol.quoteFactor,
            this.stockStress,
            this.unitPriceWithLoss,
            this.isPtax ? this.ptaxQuote : null,
            this.defaultStress,
        );

        const value = this.computerService.calculate(this.marketScenario, this.calculatingScenario, param);

        let result = this.roundWithTwoDecimalPlace(value);

        if (!isFinite(result)) {
            this.loading = true;
            result = 0;
        }

        if (this.dialogComponentReference) {
            this.dialogComponentReference.componentInstance.investmentValue = result;
        }

        return result;
    }

    public get calculatingScenario(): CalculatingScenario {
        return this.computerService.computeCalculatingScenario(this.scenarioSettings.purchase, this.isDayTrade, true);
    }

    /** Identifica se o usuario está usando produtos como garantia */
    private get usingWarranty(): boolean {
        return this.warranyUsageComponent.limitIncreased;
    }

    public get isDayTrade(): boolean {
        return this.scenarioSettings.showDayTradeInfo && this.dayTradeStatus && this.marketOpen && this.daytradeStress > 0;
    }

    public get showDayTradePanel() {
        return this.scenarioSettings.showDayTradeInfo && !this.scenarioSettings.isOption && this.daytradeStress > 0;
    }

    public get isFuture(): boolean {
        return this.symbol.typeMarket === OrderMarketTypeEnum.Future;
    }

    public get isOption(): boolean {
        return this.symbol.typeMarket === OrderMarketTypeEnum.Option;
    }

    public get maxValueForInvestiment() {
        if (!this.scenarioSettings.creatingPlanning) return Infinity;

        return (this.executedAmount / this.symbol.standardLot) * this.valueForStandardLot;
    }

    constructor(
        public dialogsService: DialogsService,
        private utilitiesService: UtilitiesService,
        protected router: Router,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder,
        private store: Store<AppState>,
        private stocksExchangeWalletEffects: StocksExchangeWalletEffects,
        private stocksExchangeCheckoutEffects: StocksExchangeCheckoutEffects,
        private computerService: ComputerService,
        private numberPipe: DecimalPipe,
        private settingsService: SettingsService,
        private changeDetectorRef: ChangeDetectorRef,
        private location: Location,
        private billingEffect: BillingEffects,
        private researchEffects: ResearchEffects,
        private routeTracker: RouterTrackerService,
        private datePipe: DatePipe,
        private currencyPipe: CurrencyPipe,
        private interactions: StocksMarketInteractionsService,
        private toastr: ToastrService,
        private icvm617Service: Icvm617Service,
    ) {
        super(dialogsService, router);

        this.form = this.formBuilder.group({
            investmentValue: 0,
            stopValue: 0,
            gainValue: 0,
        });

        this.isMobile = window.document.body.offsetWidth <= 768;
        this.trendDetails$ = this.store.select((storeTrend) => storeTrend.trends);

        this.route.data.subscribe( (item) => {
            this.scenarioSettings.editing = item.editing as boolean;
        });

        // Pega o CBLC do usuário
        this.disposableSubscriptions.push(
            this.store.select((storeAuth) => storeAuth.authentication).pipe(
                filter((result) => !!result.currentUser)
            ).subscribe((result) => {
                this.CBLC = result.currentUser.cblc;
            }),
        );

        // Pega o suitability
        this.disposableSubscriptions.push(
            this.store.select((storeSuit) => storeSuit.suitability).pipe(
                filter((result) => !!(result && result.profile))
            ).subscribe((result) => {
                this.suitability = result.profile.description;
            })
        );

        this.disposableSubscriptions.push(
            this.store.select((state) => state.agreements.agreements)
                .pipe(
                    filter((item) => item && !!item),
                )
                .subscribe((result: any) => {
                    this.rlpModelAgreement = result[AgreementsOptions.TermoAdesaoRlp.toLowerCase()];
                }),
        );

        this.disposableSubscriptions.push(
            this.store.select((state) => state.agreements.pendingAccept)
                .pipe(
                    skip(1),
                )
                .subscribe((pendingAccept) => {
                    if (!pendingAccept) {
                        this.showLoader = false;
                        if(this.rlpOption){
                            this.toastr
                                .success(
                                    `PROVEDOR DE LIQUIDEZ ATIVADO COM SUCESSO`,
                                    '',
                                    {
                                        timeOut: 7000,
                                        progressBar: true,
                                        positionClass: 'toast-bottom-center',
                                        toastClass: 'toast--default font-small--medium font-light-color',
                                    },
                                );
                        } else {
                            this.toastr
                                .error(
                                    `PROVEDOR DE LIQUIDEZ ESTÁ INATIVO`,
                                    '',
                                    {
                                        timeOut: 7000,
                                        progressBar: true,
                                        positionClass: 'toast-bottom-center',
                                        toastClass: 'toast--default font-small--medium font-light-color',
                                    },
                                );
                        }
                    }
                }),
        );

        this.disposableSubscriptions.push(
            combineLatest([
                this.store.select((state) => state.agreements.acceptedAgreements),
                this.store.select((state) => state.stocksExchange.stocksMarket.instruments)
                    .pipe(
                        filter((item) => !!item[this.stockId]),
                        map((item) => item[this.stockId]),
                    ),
            ]).pipe(
                filter(([acceptedAgreements, instrument]) => !!acceptedAgreements && !!instrument),
                map(([acceptedAgreements, instrument]) => {
                    const isFuture: boolean = instrument.typeMarket === OrderMarketTypeEnum.Future;
                    this.agreements = acceptedAgreements;
                    this.checkIfRlpHasShown(isFuture);
                })
            )
            .subscribe()
        );

        this.disposableSubscriptions.push(
            this.store.select((state) => state.userProfile)
                .subscribe((userData) => {
                    this.userIdentifier = userData.user.cpfcnpj;
                }),
        );

        const successSub = merge(
            this.stocksExchangeCheckoutEffects.editStrategy$.pipe(
                filter((item) => item.type.equals(StocksExchangeCheckoutAction.editStrategySuccess))
            ),
            this.stocksExchangeCheckoutEffects.newStrategy$.pipe(
                filter((item) => item.type.equals(StocksExchangeCheckoutAction.newStrategySuccess))
            ),
        )
            .subscribe((result) => {
                this.loading = false;
                // tslint:disable: no-string-literal
                // Dispatch que é feito pro Segment
                const segmentPayload = new OrderSentEvent(
                    SegmentCheckoutTypeEnum.PLANNED,
                    this.stockId,
                    this.stockCheckout.origin,
                    this.scenarioSettings.purchase ? SegmentOrderSideEnum.BUY : SegmentOrderSideEnum.SELL,
                    this.isFuture ? SegmentMarketTypeEnum.BMF : SegmentMarketTypeEnum.BOVESPA,
                    this.selectedLotAmount,
                    this.CBLC,
                    this.suitability,
                    this.isDayTrade,
                    'Old',
                    this.stockCheckout.category,
                    null,
                    null,
                    null,
                    null,
                    null,
                    window['toroJWTMobile'],
                    this.hasBypassedSuitabilityForCurrentInvestment
                );

                this.store.dispatch({
                    type: TrackingActions.sendOrderInformation,
                    payload: segmentPayload,
                });

                if (this.dialogComponentReference) this.dialogComponentReference.componentInstance.haveSuccess(true);

                this.showSuccessScreen();
            });

        const errorSub = merge(
            this.stocksExchangeCheckoutEffects.editStrategy$.pipe(
                filter((item) => item.type.equals(StocksExchangeCheckoutAction.editStrategyError))
            ),
            this.stocksExchangeCheckoutEffects.newStrategy$.pipe(
                filter((item) => item.type.equals(StocksExchangeCheckoutAction.newStrategyError))
            ),
        )
            .subscribe((result) => {
                this.loading = false;
                if (this.dialogComponentReference) this.dialogComponentReference.componentInstance.haveSuccess(false);
                this.store.dispatch({ type: ApplicationMessagesAction.genericError, payload: result });
            });

        this.disposableSubscriptions.push(...[successSub, errorSub]);

        this.store.dispatch({ type: BillingAction.getBrokerageModel });
        this.store.dispatch({ type: AgreementsAction.getAgreementStatus });
        this.store.dispatch({ type: AgreementsAction.getAgreementData, payload: AgreementsOptions.TermoAdesaoRlp });
        this.store.dispatch({ type: ExchangeActions.getTradingTime });
    }

    public ngOnInit() {
        const combinedSubscriptions = new Array<any>();

        this.disposableSubscriptions.push(
        combineLatest([
            this.store.select((state) => state.utils.timer),
            this.store.select((state) => state.stocksExchange.stocksMarket.instruments).pipe(
                map((items) => items[this.stockId]),
            ),
            this.store.select((state) => state.exchange.tradingTime),
        ]).pipe(
            filter(([time, instrument, tradingTime]) => !!(time && instrument && tradingTime))
        ).subscribe(([time, instrument, tradingTime]) => {
            if (instrument.securityCategory === this.securityCategory.StocksFuture) {
                let payloadCompany = {};
                payloadCompany = { symbol: this.stockId };
                this.store.dispatch({ type: StockResearchTrendAction.getCompanyTrend, payload: payloadCompany });
            }

            const limitDayTradeFuture = this.normalizeDate((tradingTime.limitDayTradeFuture as string));
            const limitDayTradeStock = this.normalizeDate((tradingTime.limitDayTradeStock as string));
            this.isSummerTime = this.getTimeZoneHour() === 2;
            // Aplicar horários do exchange
            this.DEFAULT_TIME_F_IBOVESPA = this.datePipe.transform(limitDayTradeStock, 'HH:mm');
            this.DEFAULT_TIME_F_BMF = this.datePipe.transform(limitDayTradeFuture, 'HH:mm');

            let date = time;
            let DEFAULT_TIME_F;

            const opening = instrument.typeMarket === OrderMarketTypeEnum.Future
                ? tradingTime.openingFuture
                : tradingTime.openingBovespa;

            if (opening) {
                this.openingTime = this.datePipe.transform(opening, 'HH:mm') || '';
            }

            if (instrument.typeMarket === OrderMarketTypeEnum.Future) {
                DEFAULT_TIME_F = this.DEFAULT_TIME_F_BMF;
            } else {
                DEFAULT_TIME_F = this.DEFAULT_TIME_F_IBOVESPA;
            }

            if (!date) {
                const newDate = new Date();
                date = this.datePipe.transform(newDate, 'HH:mm:ss');
            }

            if (date <= this.DEFAULT_TIME_L && date >= DEFAULT_TIME_F) {
                this.marketOpen = false;
                if (this.isDayTrade !== false) {
                    this.dayTradeStatus = false;
                    this.updatePriceBands();
                }
                this.updateWarrantyFlag();
            } else {
                this.marketOpen = true;
            }
        }));

        // recupera os dados de tendencia
        this.trendSubscribe = this.trendDetails$
            .subscribe((trend) => {
                if (trend &&  trend.companyTrend) {
                    this.trendCompany = trend.companyTrend;
                }
            });

        this.disposableSubscriptions.push(
            this.store.select((state) => state.exchangeCheckout.stockCheckout)
                .subscribe((item) => {
                    if (item) {
                        this.stockCheckout = item;
                        this.scenarioSettings.creatingPlanning = this.stockCheckout.creatingPlanning;
                        this.loading = true;
                        this.alreadyUnlocked = this.scenarioSettings.creatingPlanning;
                        this.stockId = this.stockCheckout.symbol.toUpperCase();
                        if (this.stockCheckout.adviceId) {
                            this.loadingAdvice = true;
                            this.adviceId =  this.stockCheckout.adviceId;
                            this.store.dispatch({ type: ResearchActions.getOpportunity, payload: this.adviceId });

                            this.scenarioSettings.showTogglePlanningButton =  false;
                            this.scenarioSettings.enableGainStopEditing = false;
                            this.scenarioSettings.enableDayTradeControl  = false;
                            this.scenarioSettings.isAdvice = true;
                        } else if (this.stockCheckout.strategyId) {
                            this.store.dispatch({ type: StocksExchangeWalletAction.getStrategy, payload: this.stockCheckout.strategyId});

                        } else if (this.stockCheckout.creatingPlanning) {

                            if (this.stockCheckout.orderId) {
                                this.store.dispatch({ type: StocksExchangeWalletAction.getOrder, payload: this.stockCheckout.orderId});
                            } else {
                                this.scenarioSettings.purchase = this.stockCheckout.purchase;

                                this.dayTradeStatus = false;
                                this.scenarioSettings.showDayTradeInfo = true;

                                this.executedAmount = this.stockCheckout.amount;

                                this.scenarioSettings.alreadyExecuted = true;

                                this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.stockId });
                                this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.stockId});
                            }

                            this.alreadyUnlocked = true;

                            this.scenarioSettings.showTogglePlanningButton = false;
                            const payloadPriceBand = { symbol : this.stockId, operationType: OperationType.Position };
                            this.store.dispatch({ type: ResearchActions.getPriceBands, payload: payloadPriceBand});

                        } else if (this.stockCheckout.symbol && !this.scenarioSettings.editing) {
                            let payloadPriceBand;

                            if (this.stockCheckout.isFuture) {
                                payloadPriceBand = { symbol : this.stockId, operationType: OperationType.DayTrade };
                                this.dayTradeStatus = true;
                            } else {
                                payloadPriceBand = { symbol : this.stockId, operationType: OperationType.Position };
                            }

                            this.scenarioSettings.purchase = this.stockCheckout.purchase;
                            this.scenarioSettings.showTogglePlanningButton =  false;
                            this.scenarioSettings.enableGainStopEditing = true;
                            this.scenarioSettings.enableDayTradeControl  = true;
                            this.scenarioSettings.showTogglePlanningButton = true;

                            this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.stockId });
                            this.store.dispatch({ type: ResearchActions.getPriceBands, payload: payloadPriceBand});
                            this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.stockId});
                        } else {
                            this.router.navigateByUrl('/investir');
                        }
                    } else {
                        this.router.navigateByUrl('/investir');
                    }
                }),
        );

        this.disposableSubscriptions.push(this.store.select((state) => state.billing)
            .subscribe((billing: any) => {
                if (billing.brokerageModel.type) {
                    this.usingWinWinModel = (billing.brokerageModel.type === BrokerageModel.WinWin);
                }
            }),
        );

        // Get Advice
        this.disposableSubscriptions.push(this.store.select((state) => state.research.opportunity).pipe(
            filter((item) => item && item.id === this.adviceId)
        ).subscribe((item) => {
            if (item) {
                this.advice = item;

                if (!this.advice.avaliable) {
                    this.router.navigateByUrl('/investir');
                } else {
                    this.stockId = item.symbolID.toUpperCase();
                    this.stopGainVariation = this.stopGainAnalyst = item.goal;
                    this.stopLossVariation = this.stopLossAnalyst = item.stop;
                    this.scenarioSettings.showDayTradeInfo = this.advice.isDayTrade;
                    this.dayTradeStatus = this.advice.isDayTrade;
                    this.scenarioSettings.purchase = (this.advice.side === OrderSideEnum.Compra);
                    this.loadingAdvice = false;
                    this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.stockId });
                    this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.stockId});

                    // get default stress para calculos em alguns cenários
                    this.alreadyUnlocked = false;
                    this.changeDetectorRef.detectChanges();
                }
            }
        }));

        this.disposableSubscriptions.push(
            this.researchEffects.getOpportunity$.pipe(
                filter((item) => item.type.equals(ResearchActions.getOpportunityError))
            )
                .subscribe((item) => {
                    this.router.navigateByUrl('/investir');
                }),
        );

        // Edição estratégia
        this.disposableSubscriptions.push(
            this.store.select((state) => state.stocksExchange.wallet.strategy).pipe(
                filter((item) => item)
            ).subscribe( (item) => {
                this.strategy = item;

                this.scenarioSettings.showDayTradeInfo = this.strategy.isDayTrade;

                this.input = this.strategy.legs.filter((leg) => leg.internalOrderType === OrderType.Input)[0];
                this.stopGain = this.strategy.legs.filter((leg) => leg.internalOrderType === OrderType.StopGain)[0];
                this.stopLoss = this.strategy.legs.filter((leg) => leg.internalOrderType === OrderType.StopLoss)[0];

                this.scenarioSettings.alreadyExecuted = (
                    (this.input.status === OrderStatus.PartiallyFilled) ||
                    (this.input.status === OrderStatus.Filled) ||
                    (this.input.status === OrderStatus.TurnOnPlanned)
                );
                this.lockInvestValue = this.scenarioSettings.alreadyExecuted;
                this.scenarioSettings.purchase = this.input.side === OrderSideEnum.Compra;

                this.scenarioSettings.alreadySent = (this.input.status === OrderStatus.ScheduledNew);

                this.scenarioSettings.showTogglePlanningButton = this.scenarioSettings.alreadyExecuted;

                if (!this.scenarioSettings.alreadyExecuted) {
                    this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.stockId});
                } else {
                    this.unitPrice = this.input.avaragePriceExecuted;
                }

                this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.stockId });
            }),
        );

        this.disposableSubscriptions.push(
            this.stocksExchangeWalletEffects.getStrategy$.pipe(
                filter((strategy) => strategy.type.equals(StocksExchangeWalletAction.strategyNotFound))
            ).subscribe((item) => {
                this.router.navigateByUrl('/investir');
            }),
        );

        this.disposableSubscriptions.push(
            this.store.select((state) => state.stocksExchange.wallet.order).pipe(
                filter((item) => item)
            ).subscribe((order) => {
                this.input = order;
                this.scenarioSettings.alreadySent = true;
                this.scenarioSettings.alreadyExecuted = (
                    (this.input.status === OrderStatus.PartiallyFilled) ||
                    (this.input.status === OrderStatus.Filled) ||
                    (this.input.status === OrderStatus.TurnOnPlanned)
                );

                this.scenarioSettings.showDayTradeInfo = this.input.isDayTrade;

                this.executedAmount = this.input.orderQty;

                if (!this.scenarioSettings.alreadyExecuted) {
                    this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.stockId});
                } else {
                    this.unitPrice = this.input.avaragePriceExecuted;
                }

                this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.stockId });
            }),
        );

        combinedSubscriptions.push(
            this.store.select((state) => state.stocksExchange.stocksMarket.instruments)
                .filter((item) => (item[this.stockId]) ? true : false)
                .map((item) => item[this.stockId]),
        );

        if (!this.scenarioSettings.isAdvice && (!this.scenarioSettings.editing || this.scenarioSettings.creatingPlanning)) {
            combinedSubscriptions.push(
                this.store.select((state) => state.research.priceBand)
                    .filter((item) => item),
            );
        }

        if (this.scenarioSettings.editing) {
            combinedSubscriptions.push(
                this.store.select((state) => state.stocksExchange.wallet.strategy)
                    .filter((item) => item),
            );
        }

        /**
         * Espera as 3 chamadas retornarem no carregamento da tela, mas não trata o valor de
         * Price bands para não haver sobrescrita de valores durate a interação do usuário
         */
        this.disposableSubscriptions.push(
            Observable.combineLatest(...combinedSubscriptions)
                .pipe(
                    first(),
                )
                .subscribe(([instrument, priceBand, strategy]) => {
                    this.symbol = instrument;
                    this.symbolLogo = this.symbol.logo.content;
                    this.defaultStress = (this.symbol.stress as IStressResponse).value;
                    this.stockStress = (this.symbol.stress as IStressResponse).dayTradeStrategyValue;
                    this.daytradeStress = (this.symbol.stress as IStressResponse).dayTradeValue;
                    this.isPtax = (this.symbol.stress as IStressResponse).isPtax;
                    this.stockMarket = this.symbol.typeMarket;

                    this.HandleSymbolQuote(this.symbol);

                    // Verifica se o checkout pode ser usado com o instrumento selecionado
                    // this.checkInstrumentMarket(instrument as Instrument);

                    if (this.scenarioSettings.editing) { // para edição usa a quantidade da ordem enviada
                        this.selectedLotAmount = this.input.orderQty;
                    } else if (this.scenarioSettings.creatingPlanning) {
                        this.selectedLotAmount = this.executedAmount; // para planejamento usa a quantidade já executada
                    } else {
                        this.selectedLotAmount = this.symbol.standardLot; // para o resto usa o lote padrão do instrumento
                    }

                    if (this.scenarioSettings.editing) this.updateStopValues();

                    this.loadMarketScenario();

                    if (this.isPtax && !this.ptaxAlreadySubscribed) {
                        this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.DOLAR_PTAX});
                        this.ptaxAlreadySubscribed = true;
                    }

                    this.loading = false;
                    this.updateWarrantyFlag();
                    if (
                        this.scenarioSettings.creatingPlanning ||
                        (this.scenarioSettings.editing && this.strategy && this.strategy.originType !== OrderOriginTypeEnum.Analyst)
                    ) {
                        this.alreadyUnlocked = true;
                    }

                    this.changeDetectorRef.detectChanges();
                }));

        this.disposableSubscriptions.push(
            this.store.select((state) => state.stocksExchange.stocksMarket.quote)
                .filter((item) => item[this.stockId])
                .map((item) => item[this.stockId])
                .subscribe((quote) => {
                    this.HandleSymbolQuote(quote);
                }),
        );

        this.disposableSubscriptions.push(
            this.store.select((state) => state.research.priceBand)
                .filter((item) => item[this.stockId])
                .map((item) => item[this.stockId])
                .subscribe((priceBand) => {
                    this.HandlePriceBands(priceBand);
                }),
        );

        this.disposableSubscriptions.push(
            this.store.select((state) => state.stocksExchange.stocksMarket.quote)
                .filter((item) => item[this.DOLAR_PTAX])
                .map((item) => item[this.DOLAR_PTAX])
                .subscribe((ptax) => {
                    this.ptaxQuote = ptax.PriceLastTrade || ptax.OpeningPrice || ptax.ClosingPricePreviousDay;
                }),
        );

        this.form.get('gainValue').valueChanges
            .subscribe((data) => { this.onGainValueChanged(); });
        this.form.get('stopValue').valueChanges
            .subscribe((data) => { this.onStopValueChanged(); });

        this.disposableSubscriptions.push(

            this.billingEffect.getBrokerageTax$.subscribe((item) => {

                if (item.type.equals(BillingAction.getBrokerageTaxSuccess)) {
                    this.brokerageTax = item.payload.brokerageValue;
                } else {
                    this.brokerageTax = null;
                }

                if (this.stockCheckout.creatingPlanning) {
                    this.alreadyUnlocked = true;
                }
                this.openResumeComponent();
            }),

            this.store.select(state => state['suitabilityBypassAgreement'])
                .filter(data => !!data)
                .subscribe(data => {
                    this.hasBypassedSuitabilityForCurrentInvestment = this.symbol.typeMarket === OrderMarketTypeEnum.Future
                        ? data.suitabilityBypassAgreement.bmfAccepted
                        : data.suitabilityBypassAgreement.bovespaAccepted
                })
        );

        this.updateWarrantyFlag();
    }

    public initTime() {
        const actualTime = new Date();

        let date = actualTime.toLocaleTimeString();
        let DEFAULT_TIME_F;

        DEFAULT_TIME_F = this.DEFAULT_TIME_F_IBOVESPA;

        if (!date) {
            const newDate = new Date();
            date = this.datePipe.transform(newDate, 'HH:mm:ss');
        }

        if (date <= this.DEFAULT_TIME_L && date >= DEFAULT_TIME_F) {
            this.marketOpen = false;
            if (this.isDayTrade !== false) {
                this.dayTradeStatus = false;
                this.updatePriceBands();
            }
            this.updateWarrantyFlag();
        } else {
            this.marketOpen = true;
        }
    }

    /**
     * Recupera o fuso horário do usuário;
     */
    public getTimeZoneHour() {
        const date = new Date();
        const timeZone = date.getTimezoneOffset() / 60;
        return Math.abs(timeZone);
    }

    public HandleSymbolQuote(quote: any) {
        // Preço Unitário = Última Cotação senão Preço de Abertura senão Preço de Fechamento
        this.stress = quote.Stress;
        if (quote.Stress) {
            this.defaultStress = quote.Stress.Value;
            this.stockStress = quote.Stress.DayTradeStrategyValue;
            this.daytradeStress = quote.Stress.DayTradeValue;
            this.isPtax = quote.Stress.IsPtax;
        }

        this.unitPrice =
            quote.PriceLastTrade ||
            quote.OpeningPrice ||
            quote.ClosingPricePreviousDay ||
            quote.priceLastTrade ||
            quote.openingPrice ||
            quote.closingPricePreviousDay;
        this.timeLastQuote = new Date(quote.DateTimeLastTrade);
    }

    public HandlePriceBands(priceBands: any) {
        this.stopGainVariation = this.stopGainAnalyst = priceBands.goal;
        this.stopLossVariation = this.stopLossAnalyst = priceBands.stop;

        this.alreadyUnlocked = false;
        this.lockStopValue = true; // Destranca o input
        this.lockGainValue = true;

        this.gainValueInput.undoPreviouslyUnlocked();
        this.stopValueInput.undoPreviouslyUnlocked();
    }

    public updateStopValues() {

        let gainVariation = this.stopGain.price - this.unitPrice;
        let lossVariation = this.unitPrice - this.stopLoss.price;

        if (!this.isFuture) {
            gainVariation = (gainVariation * 100) / this.unitPrice;
            lossVariation = (lossVariation * 100) / this.unitPrice;
        }

        this.stopLossVariation = lossVariation;
        this.stopGainVariation = gainVariation;
    }

    public loadMarketScenario() {
        if (this.stockMarket === OrderMarketTypeEnum.Stock || this.stockMarket === OrderMarketTypeEnum.Option) {
            this.marketScenario = MarketScenario.StockAndOptions;
        } else {
            if (this.isPtax) {
                this.marketScenario = MarketScenario.FuturePtax;
            } else {
                this.marketScenario = MarketScenario.FutureWithoutPtax;
            }
        }
    }

    /**
     * Abre modal de confirmação
     * Usado em:
     * - Editar valor de 'para ganhar aprox'
     * - Editar valor de 'perder aprox'
     * - Quando o usuário quer alterar a opção de daytrade e estiver dentro do horário do pregão
     */
    public openModalConfirm(title: string, message: string, confirm: string, cancel: string = 'Cancelar'): Observable<boolean> {
        return this.dialogsService.confirmAction(title, message, confirm, cancel);
    }

    /**
     * Abre modal simples
     * Usado quando:
     * - Usuário não pode alterar a opção de daytrade por causa do horário do horário do pregão
     */
    public openModalSimple(title: string, message: string, button: string) {
        return this.dialogsService.showSimpleModal(title, message, button);
    }

    /** Valor do investimento: fim de edição */
    public onValueToInvestEditingEnd(event) {
        this.lockInvestValue = true;
    }

    /** Valor do gain: fim de edição */
    public onGainEditingEnd(event) {
        this.lockGainValue = true;
    }

    /** Valor do stop: fim de edição */
    public onStopEditingEnd() {
        this.lockStopValue = true;
    }

    public onGainValueChanged() {
        this.stopGainVariation = this.calculateStopVariation(this.form.controls.gainValue.value);
    }

    public onStopValueChanged() {
        this.stopLossVariation = this.calculateStopVariation(this.form.controls.stopValue.value);
    }

    /** Handler acionado quando o usuário solicita edicão do valor a ser investido */
    public onInvestValueEditRequest(event) {
        this.lockInvestValue = false;
        this.lockGainValue = true;
        this.lockStopValue = true;
        this.onValuesLockingChange.emit(false);
    }

    /**
     * Handler acionado quando o usuário solicita edicão do valor do ganho/gain/lucro
     */
    public onGainValueEditRequest(event) {
        if (!event.previousUnlocked && !this.alreadyUnlocked) {
            this.openModalConfirm(
                'Você realmente quer editar o lucro?',
                `Se editar o lucro você perde a corretagem Ganha-ganha. Você vai ser cobrado pela tabela tradicional.
                <a href='${this.urlPriceTable}' target='_blank' class='link link--primary'>Clique aqui</a> para ver os valores.`,
                'Editar',
            )
                .subscribe((result) => {
                    if (result) {
                        this.lockGainValue = false; // Destranca o input
                        this.lockStopValue = true;
                        this.gainValueEditingEnabled = result;
                        this.alreadyUnlocked = true;
                    } else {
                        this.lockGainValue = true; // Tranca o input
                    }
                });
        } else {
            this.lockGainValue = false; // Destranca o input
            this.lockStopValue = true;
        }
        this.onValuesLockingChange.emit(this.lockGainValue); // Emite se o input foi modificado ou não
    }

    /**
     * Handler acionado quando o usuário solicita edicão do valor do stop/perda/prejuízo
     */
    public onStopValueEditRequest(event) {
        if (!event.previousUnlocked && !this.alreadyUnlocked) {

            let text = `Se editar o prejuízo, você perde a corretagem Ganha-ganha. Você vai ser cobrado pela tabela tradicional.
            <a href='${this.urlPriceTable}' target='_blank' class='link link--primary'>Clique aqui</a> para ver os valores.`;
            if (this.isDayTrade) {
                text = `Se editar o prejuízo, o valor necessário para investir muda e você perde a corretagem Ganha-ganha.
                Você vai ser cobrado pela tabela tradicional.
                <a href='${this.urlPriceTable}' target='_blank' class='link link--primary'>Clique aqui</a> para ver os valores.`;
            }

            this.openModalConfirm('Você realmente quer editar o prejuízo?', text, 'Editar')
                .subscribe((result) => {
                    if (result) {
                        /**
                         * Troca o valor da variável auxiliar para verificação
                         * da edição dos dois campos de 'Ganho' e 'Prejuízo'.
                         * É usada na função onGainValueEditRequest que só abre a modal
                         * se o usuário não tiver liberado a edição de Prejuízo.
                         */
                        this.stopValueEditingEnabled = result;
                        this.lockStopValue = false; // Destranca o input
                        this.lockGainValue = true;
                        this.alreadyUnlocked = true;

                    } else {
                        this.lockStopValue = true; // Tranca o input
                    }
                });
        } else {
            this.lockStopValue = false; // Destranca o input
            this.lockGainValue = true;
        }
        this.onValuesLockingChange.emit(this.lockGainValue); // Emite se o input foi modificado ou não
    }

    /**
     * Handler adicionado quando o usuário solicita ligar/desligar a opção de daytrade
     */
    public onEditDayTrade(event) {

        if (!this.scenarioSettings.enableDayTradeControl) return;

        // [DESLIGAR] Verifica se ainda está no horário do pregão e se o usuário está com daytrade habilitado
        if (this.marketOpen && this.dayTradeStatus) {
            let message = `Desligando o encerramento automático será necessário um valor maior para investir, aumentando seu risco.`;
            if (this.scenarioSettings.editing) {
                message = `Desligando o encerramento automático o valor para investir aumenta.
                A diferença será cobrada da sua conta corrente da Toro.`;
            }

            this.openModalConfirm('Você realmente quer desligar o encerramento automático?', message, 'Desligar')
                .subscribe((result) => {
                    if (result) {
                        if (!this.usingWarranty && !this.scenarioSettings.purchase && !this.isFuture) {
                            this.changePlanningModal(this.isFuture, () => {
                                this.dayTradeStatus = false;
                                this.alreadyUnlocked = true;
                                this.updatePriceBands();
                                this.updateWarrantyFlag();
                            });
                        } else {
                            this.dayTradeStatus = false; // Desabilita o daytrade
                            this.alreadyUnlocked = true;
                            this.updatePriceBands();
                            this.updateWarrantyFlag();
                        }
                    }
                });
        } else if (this.marketOpen && !this.dayTradeStatus) {
            if (this.scenarioSettings.editing || this.scenarioSettings.creatingPlanning) {
                const message = `Ligando o encerramento automático o valor para investir diminui.
                A diferença será transferida para sua conta corrente da ${ environment.isNewBrand ? "Santander Corretora" : "Toro" }. `;
                this.openModalConfirm('Você quer ligar o encerramento automático?', message, 'Ligar')
                    .subscribe((result) => {
                        if (result) {
                            this.dayTradeStatus = true;
                            this.updatePriceBands();
                            this.updateWarrantyFlag();
                        }
                    });
            } else {
                this.dayTradeStatus = true;
                this.updatePriceBands();
                this.updateWarrantyFlag();
            }
        }
    }

    public onTogglePlanningClick() {

        if ((!this.usingWarranty && this.isFuture) || (!this.usingWarranty && !this.scenarioSettings.purchase && !this.isFuture)) {
            this.changePlanningModal(this.isFuture, this.turnOffPlanning);
        } else {
            this.turnOffPlanning();
        }
    }

    public confirmInvestment() {
        const subscription = this.icvm617Service.userIsBlocked()
        .subscribe((userIsBlockedIcvm617) => {
            if (userIsBlockedIcvm617) {
                this.showWarningUserBlockedIcvm617();
            } else {
                this.warrantyValue = this.value;

                if (this.value > this.avaliableValueToInvest) {
                    if (this.usingWarranty) {
                        this.showInsufficientGuaranteeWarning(); // garantia insuficiente
                    } else {
                        this.showInsufficientFundsWarning(); // saldo insuficiente
                    }
                    return;
                }

                this.loading = true;

                if (this.alreadyUnlocked || !this.usingWinWinModel) {
                    const obj = {
                        isDaytrade: this.isDayTrade,
                        orderQty: this.selectedLotAmount,
                        platform: this.BROKERAGE_PLATFORM,
                        price: this.unitPrice,
                        symbol: this.stockId
                    };
                    this.store.dispatch({ type: BillingAction.getBrokerageTax, payload: obj});
                } else {
                    this.openResumeComponent();
                }
            }
         });

        this.disposableSubscriptions.push(subscription);
    }

    /**
     * Entra em contato com o serviço e solicita realização do investimento
     */
    public sendInvestmentRequest() {
        this._suitabilityBypass();
        const isDaytrade = this.isDayTrade;
        const legs = [];
        const originType = this.getOrginType();

        legs.push(this.getInputOrder());
        legs.push(this.getStopGainOrder());
        legs.push(this.getStopLossOrder());

        const strategy: StrategyRequest = new StrategyRequest(this.stockId, isDaytrade, this.stockCheckout.adviceId, originType, legs);

        if (this.scenarioSettings.editing) {
            strategy.id = this.stockCheckout.strategyId;
            this.store.dispatch({ type: StocksExchangeCheckoutAction.editStrategy, payload: { data: strategy } });
        } else {
            this.store.dispatch({ type: StocksExchangeCheckoutAction.newStrategy, payload: { data: strategy } });
        }

    }

    /**
     * Abre o modal com dados sobre a empresa
     */
    public openAboutCompany() {
        this.dialogsService.showComponnent(
            OverlaySimpleComponent,
            {
                title: `Sobre a ${this.symbol.descriptionStock}`,
                content: this.trendCompany ? this.trendCompany.about : '',
                closeButton: 'Fechar',
            },
        );
    }

    /**
     * Handler para detectar mudanças no valor do investimento
     */
    public onInvestValueChange(changed) {
        this.lockGainValue = true;
        this.lockStopValue = true;
        this.selectedLotAmount = Math.round((this.form.controls.investmentValue.value / this.valueForStandardLot) * this.symbol.standardLot);
    }

    public cancel() {
        this.store.dispatch({ type: StocksExchangeCheckoutAction.setStockCheckout, payload: null});
        this.routeTracker.back();
    }

    @HostListener('document:keydown', ['$event'])
    public onKeyPress(event: KeyboardEvent) {
        if (event.shiftKey && event.key === easterEggKey) {
            this.counter++;
            if (this.counter > disclaimerEasterEggTriggerAmount) {
                this.counter = 0;
            }
        }
    }

    /**
     * Caso não encontre a logo para empresa, exibe a logo placeholder.
     * @param event Evento do DOM
     */
    public noLogoHandler(event) {
        this.symbolLogo = STOCK_LOGO_PLACEHOLDER;
    }

    /**
     * Método para ajustar a string do tradingHour que está vindo da webapi
     * GAMBIARRA!! REMOVER QUANDO ARRUMAREM NA API.
     */
    public normalizeDate(date: string) {
        const today = new Date();
        const todayIso = today.toISOString()
            .split('T');
        const dateISO = date.split('T');
        return `${todayIso[0]}T${dateISO[1]}`;
    }

    /**
     * Método para exibir dialog de ativação do RLP
     */
    public showRlpDialog() {

        this.trackUserActions('Loaded a Page', 'Alert RLP');

        this.openModalConfirm(
            'Ative o Provedor de Liquidez e ganhe agilidade nos seus investimentos',
            `Ativando o Provedor de Liquidez, suas operações de Míni Índice e Míni Dólar serão executadas com mais rapidez e com preço
            melhor ou igual ao de mercado. <a href='${this.rlpInfoUrl}' target='_blank' class='link link--primary'>Saiba mais</a>.`,
            'Ative Grátis',
            'Não Ativar',
        )
            .subscribe( (activate) => {
                this.showLoader = true;
                if (activate) {
                    this.trackUserActions('RLP Enabled', '');
                    this.rlpOption = true;
                } else {
                    this.trackUserActions('RLP Disabled', '');
                    this.rlpOption = false;
                }

                this.persistRlpAgreement();
            });
    }

    /**
     * Método para mostrar dialog de RLP
     */
    public checkIfRlpHasShown(isFuture: boolean) {
        const rlpAgreement = this.agreements.filter((agreement) => agreement.contractGuid === AgreementsOptions.TermoAdesaoRlp.toLowerCase());

        if (isFuture && !rlpAgreement.length) {
            this.showRlpDialog();
        }
    }

    public trackUserActions(event, action) {
        this.sendToTracking(event, {userLogin: this.userIdentifier, element: action});
    }

    public sendToTracking(typeAction, eventsTracking) {
        const payloadUser = {type: typeAction, events: eventsTracking};
        this.store.dispatch({type: TrackingActions.trackEvents, payload: payloadUser});
    }

    public ngOnDestroy() {
        this.store.dispatch({ type: StocksExchangeWalletAction.resetStrategy });
        this.store.dispatch({ type: StocksExchangeWalletAction.resetOrder });
        this.disposableSubscriptions.forEach((subscription) => {
            if (subscription) {
                subscription.unsubscribe();
            }
        });
        this.changeDetectorRef.detach();
    }

    private persistRlpAgreement() {
        this.store.dispatch({
            type: AgreementsAction.acceptAgreement,
            payload: {
                contractGuid: this.rlpModelAgreement.contractGuid,
                versionId: this.rlpModelAgreement.versionID,
                status: this.rlpOption,
                agreementId: this.rlpModelAgreement.id,
            },
        });
    }

    private roundWithTwoDecimalPlace(value: number) {
        return Math.ceil(value * 100) / 100;
    }

    /**
     * Verifica se o instrumento da operação pode ser usado no checkout planejado.
     * Futuro de ações não serão usados
     * @param instrument instrumento da operação
     */
    private checkInstrumentMarket(instrument: Instrument) {
        if (instrument.securityCategory === SecurityCategory.StocksFuture) {
            this.router.navigateByUrl('/checkout');
        }
    }
    /**
     * Abre o modal de confirmação do resumo.
     */
    private openResumeComponent() {

        // Variável para controlar a abertura da gaveta novamente.
        if ( this.successScreenIsVisible ) return;

        const obj = {
            investmentValue: this.valueForInvestiment,
            isDayTrade: this.isDayTrade,
            usingWarranty: this.usingWarranty,
            warrantyValue: this.warrantyValue,
            planned: true,
            incompatibleProfile: this.scenarioSettings.incompatibleProfile,
            purchase: this.scenarioSettings.purchase,
            unlocked: this.alreadyUnlocked || !this.usingWinWinModel,
            isFuture: this.isFuture,
            brokerage: this.brokerageTax,
            brokerageFactor: this.symbol.brokerageFactor,
            suitability: this.suitability
        };

        this.loading = true;

        return this.interactions.onPlannedInvestimentAttempt(this.stockMarket)
            .then((result) => {
                // Mercado fechado ou usuário não quis agendar
                if (!result.confirm) {
                    this.loading = false;
                    this.dialogComponentReference = null;
                    return;
                }

                const reference = this.dialogsService.showComponentAsAsidePanel(InvestmentResumeComponent, true, obj);
                this.dialogComponentReference = reference as MatDialogRef<InvestmentResumeComponent>;

                this.disposableSubscriptions.push(
                    this.dialogComponentReference.componentInstance.sendInvestmentSubject
                        .subscribe((data) => {
                            if (data) {
                                this.sendInvestmentRequest();
                            }
                        }),
                );

                this.disposableSubscriptions.push(
                    this.dialogComponentReference.afterClosed()
                        .subscribe((data) => {
                            this.loading = false;
                            this.dialogComponentReference = null;
                        }),
                );
            });
    }

    /**
     * Método utilizado para calcular o preço do Gain e do Loss de acordo com o Lado
     */
    private calculateStopPrice(purchase: boolean, gain: boolean, variation: number) {
        // se compra e gain + (soma)
        // se compra e loss - (subtrai)
        // se venda e gain - (subtrai)
        // se venda e loss + (soma)
        if ((purchase && !gain) || (!purchase && gain)) {
            variation = variation * -1;
        }

        if (this.isFuture) {
            return this.unitPrice + variation;
        } else {
            return this.unitPrice * (1 + (variation / 100));
        }
    }

    /**
     *  Criar estratégia de recomendação (oportunidade) -> Analyst
     *  Criar estratégia respeitando a gain e loss definido pelos analistas ->  Analyst
     *  Criar estratégia com gain ou loss alterado pelo usuário -> Client
     *  Criar estratégia a partir de ordem/posição dormida -> Client
     *  Edição de estratégia executada marcada como Analyst -> Analyst Updated
     *  Edição de estratégia não executada marcada como Analyst ->  Client
     *  Edição de estratégia marcada como Client -> Client
     */
    private getOrginType(): OrderOriginTypeEnum {

        if (!this.scenarioSettings.editing && !this.scenarioSettings.creatingPlanning) { // Criando uma nova estratégia
            // se perdeu ganha-ganha ? Cliente : Analista
            return this.alreadyUnlocked ? OrderOriginTypeEnum.Client : OrderOriginTypeEnum.Analyst;
        } else {
            if (this.scenarioSettings.creatingPlanning) { // Criando estratégia a partir de ordem/posição dormida
                return OrderOriginTypeEnum.Client;
            }

            if (this.strategy.originType === OrderOriginTypeEnum.Analyst) { // Edição de estratégia executada marcada como Analyst
                return this.input.status === OrderStatus.ScheduledNew ? OrderOriginTypeEnum.Client : OrderOriginTypeEnum.AnalystReplaced;
            }

            return OrderOriginTypeEnum.Client;
        }
    }

    private getInputOrder() {
        const order = new StockOrderType();

        order.symbol = this.stockId;
        order.orderQty = this.selectedLotAmount;
        order.isDaytrade = this.isDayTrade;
        order.originType = this.getOrginType();
        order.suitabilityNonConformityConsent = this.hasBypassedSuitabilityForCurrentInvestment;

        if (!this.isFuture) {
            order.priceType = StrategyRequestLegPriceType.Market;
        } else {
            order.priceType = StrategyRequestLegPriceType.MarketWithLeftOverAsLimit;
        }
        order.validityType = StrategyRequestLegValidityType.FillOrKill;
        order.internalOrderType =  StrategyRequestOrderType.Input;

        if (this.scenarioSettings.creatingPlanning) {
            order.virtualType = VirtualTypeEnum.Position;
        }

        if (this.stockCheckout.orderId) {
            order.id = this.stockCheckout.orderId;
        }

        if (this.scenarioSettings.editing) {
            order.id = this.input.id;
        }

        order.side = this.scenarioSettings.purchase ? OrderSideEnum.Compra : OrderSideEnum.Venda;

        return order;
    }

    private getStopLossOrder() {
        const order = new StockOrderType();

        order.symbol = this.stockId;
        order.orderQty = this.selectedLotAmount;
        order.isDaytrade = this.isDayTrade;
        order.originType = this.getOrginType();

        if (!this.isFuture) {
            order.priceType = StrategyRequestLegPriceType.Market;
        } else {
            order.priceType = StrategyRequestLegPriceType.MarketWithLeftOverAsLimit;
        }
        order.validityType = StrategyRequestLegValidityType.FillOrKill; // confirmar
        order.internalOrderType =  StrategyRequestOrderType.StopLoss;

        order.price = this.roundWithTwoDecimalPlace(this.unitPriceWithLoss);
        order.paramLoss = this.roundWithTwoDecimalPlace(this.stopLossVariation);

        if (this.scenarioSettings.editing) {
            order.id = this.stopLoss.id;
        }

        // para ordens de Stop Gain e Loss o lado é o contrário do input
        order.side = this.scenarioSettings.purchase ? OrderSideEnum.Venda : OrderSideEnum.Compra;

        return order;
    }

    private getStopGainOrder() {
        const order = new StockOrderType();

        order.symbol = this.stockId;
        order.orderQty = this.selectedLotAmount;
        order.isDaytrade = this.isDayTrade;
        order.originType = this.getOrginType();

        if (!this.isFuture) {
            order.priceType = StrategyRequestLegPriceType.Market;
        } else {
            order.priceType = StrategyRequestLegPriceType.MarketWithLeftOverAsLimit;
        }
        order.validityType = StrategyRequestLegValidityType.FillOrKill;
        order.internalOrderType =  StrategyRequestOrderType.StopGain;

        order.price = this.roundWithTwoDecimalPlace(this.unitPriceWithGain);
        order.paramGain = this.roundWithTwoDecimalPlace(this.stopGainVariation);

        if (this.scenarioSettings.editing) {
            order.id = this.stopGain.id;
        }

        // para ordens de Stop Gain e Loss o lado é o contrário do input
        order.side = this.scenarioSettings.purchase ? OrderSideEnum.Venda : OrderSideEnum.Compra;

        return order;
    }

    /**
     * Mostra recibo para o usuário
     */
    private showSuccessScreen() {

        // Variável usada para evitar que a gaveta se abra mesmo depois de já ter finalizado investimento
        this.successScreenIsVisible = true;
        // Investimento agendado
        if (!this.marketOpen) {
            const operation = this.scenarioSettings.purchase ? 'compra' : 'venda';
            const executedLabel = this.scenarioSettings.purchase ? 'comprado' : 'vendido';
            this.showSuccessMessageResult(
                `Ordem de ${operation} agendada com sucesso.`,
                `A sua ordem de ${operation} foi agendada com sucesso e será processada a partir das ${this.openingTime} do próximo dia útil.
                Você pode acompanhar esta ordem e conferir se este investimento foi ${executedLabel} na área de Meus Investimentos.`,
                'waiting',
            );
            return;
        }

        // Planejamento criado
        if (this.scenarioSettings.creatingPlanning) {
            this.showSuccessMessageResult(
                `Planejamento criado com sucesso.`,
                `Você pode acessar a área de <strong>Meus Investimentos</strong> dentro de Bolsa para acompanhar o seu investimento.`,
            );
            return;
        }

        // Caso não seja uma edição finalizada
        if (this.scenarioSettings.alreadyExecuted) {
            this.showSuccessMessageResult(
                `Investimento editado com sucesso.`,
                `Você pode acessar a área de <strong>Meus Investimentos</strong> dentro de Bolsa para acompanhar o seu investimento.`,
            );
            return;
        }

        // Caso não seja uma edição
        if (!this.scenarioSettings.editing) {
            const side = this.scenarioSettings.purchase ? 'compra' : 'venda';
            const action = this.scenarioSettings.purchase ? 'comprado' : 'vendido';
            this.showSuccessMessageResult(
                `Ordem de ${side} enviada com sucesso.`,
                `A sua ordem de ${side} foi registrada com sucesso.
                Você pode acompanhar esta ordem e conferir se este investimento foi ${action} na área de Meus Investimentos.`,
            );
            return;
        }

        // Edição
        this.showSuccessMessageResult(
            `Compra planejada editada com sucesso.`,
            `Você pode acessar a área de <strong>Meus Investimentos</strong> dentro de Bolsa para editar,
            cancelar e acompanhar se a sua ordem foi executada. `,
        );
    }

    /**
     * Retorna tipo de unidade que cada mercado negocia (contratos, acoes, opcoes)
     * @param usePlural se deve retornar o valor em plural
     */
    private getUnitNameByMarket(usePlural: boolean = false) {
        switch (this.symbol.typeMarket) {
            case OrderMarketTypeEnum.Future:
                return usePlural ? 'contratos' : 'contrato';
            case OrderMarketTypeEnum.Option:
                return usePlural ? 'opções' : 'opção';
            default:
                return usePlural ? 'ações' : 'ação';
        }
    }

    private calculateStopVariation(userValue: number) {
        const pQuote = this.isPtax ? this.ptaxQuote : 1;
        const ptaxValue = this.isPtax ? pQuote : 1;
        let result = userValue / (this.selectedLotAmount * this.symbol.quoteFactor * ptaxValue);

        if (!this.isFuture) {
            result = (result * 100) / this.unitPrice;
        }

        return result;
    }

    private updatePriceBands() {
        if (!this.scenarioSettings.isAdvice) {
            const operationTypeStr = this.isDayTrade ? 'DayTrade' : 'Position';
            const payloadPriceBand = { symbol : this.stockId, operationType: operationTypeStr };
            this.store.dispatch({ type: ResearchActions.getPriceBands, payload: payloadPriceBand});
        }
    }

    /**
     * método que controla a flag usada para saber se o usuário Modelo 2 deve usar somente o saldo ou outros investimentos como garantia
     * para casos de Compra, Bovespa e não Daytrade, ele deve usar somente o saldo em conta
     */
    private updateWarrantyFlag() {
        const isBovespa =  this.stockMarket === undefined || this.stockMarket === OrderMarketTypeEnum.Stock;
        this.isBovespaBuyPosition = (isBovespa && !this.isDayTrade && this.scenarioSettings.purchase);
    }

    /**
     * Abre o modal de mudança de garantia.
     * @param isFuture Se é futuro ou não
     * @param callback Callback caso execute uma função.
     */
    private changePlanningModal(isFuture: boolean, callback: () => void) {
        const customMessage = `Para fazer uma operação de venda fora do investimento planejado
            ou sem a estratégia de encerrar no mesmo dia é preciso autorizar que suas ações e títulos de renda fixa
            sejam usados como garantia.Depois que autorizar este processo, sempre que fizer investimentos em
            <span class='popover-link'>futuros</span>
            ou investimentos em Bolsa planejados e com duração máxima de 1 dia, o valor não será mais debitado na conta
            corrente. Ao invés disso, o valor aparecerá como investimento em Bolsa até que seja encerrado.
            O lucro/prejuízo dos investimentos será debitado/creditado diretamente na sua conta corrente da corretora.`;

        const customMessageFuture = `Para investir em <span class='popover-link'>futuros</span>
            fora do investimento planejado é preciso autorizar que suas
            ações e títulos de renda fixa sejam usados como garantia. Depois que autorizar este processo, sempre que fizer
            investimentos em futuros ou investimentos em Bolsa planejados e com duração máxima de 1 dia, o valor não será mais
            debitado na conta corrente. Ao invés disso, o valor aparecerá como investimento em Bolsa até que seja encerrado.
            O lucro/prejuízo dos investimentos será debitado/creditado diretamente na sua conta corrente da corretora.`;

        this.dialogsService
            .showComponnent(ConfirmEnableWarrantyComponent, {customMessage: isFuture ? customMessageFuture : customMessage})
            .afterClosed()
            .filter((result) => result ? true : false)
            .subscribe( () => callback());
    }

    /**
     * Desliga Planejamento
     */
    private turnOffPlanning() {
        const item = new StockCheckoutType();
        item.symbol = this.stockId;
        item.purchase = this.scenarioSettings.purchase;
        item.origin = this.stockCheckout.origin;
        item.isFuture = this.isFuture;

        let url = '/checkout';

        if (this.scenarioSettings.editing) {
            item.inputOrder = this.input;
            item.strategyId = this.strategy.strategyId;
            url += '/editar';
        }

        this.store.dispatch({ type: StocksExchangeCheckoutAction.setStockCheckout, payload: item});
        this.router.navigateByUrl(url);
    }

    // Envia o aceite do usuário de investimento incompativel com perfil de suitability
    private _suitabilityBypass() {
        if (!this.hasBypassedSuitabilityForCurrentInvestment) {
            this.store.dispatch({ type: SuitabilityBypassAgreementActions.updateSuitabilityBypassAgreement, payload: { data: { "marketType": this.isFuture ? "Future" : "Bovespa" } } });
            this.hasBypassedSuitabilityForCurrentInvestment = true;
        }
    }


    /**
     * Método que extrai a hora de um timezone
     * @param string
     */
    private extractTimeToDatetime(dateString: string): string {

        const datetime = dateString
            .split('T')
            .pop();

        return datetime.split('-')[0]
            .substring(0, 5);
    }
}
